import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { cloneDeep, get, isEmpty, uniq, without } from 'lodash';
import moment from 'moment-timezone';
import hash from 'object-hash';
import RecapADD from 'containers/common/LegalProceedings/AppealAdd/index';
import { addDaysToDate } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/utils';
import { Listings } from 'containers/AppContainer/typings';
import {
  IJudgementAdd,
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import { JudgementAddDecisionStyle } from 'containers/CourtManagerLegalProceedings/styled-components';
import recapManagerMessages from 'containers/RecapManagerPage/messages';
import { arrayTranslate, translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import RefusalDialog from 'containers/CourtManagerLegalProceedings/AppealAdd/Dialogs/RefusalDialog';
import {
  DETAIL_JUGEMENT_ADD,
  EMPTY_DETAIL,
  JUDGEMENT,
} from 'containers/data-structure';
import { shouldDisplayAddDecisionMenu } from 'containers/CourtManagerLegalProceedings/JudgementAdd/utils';
import {
  CURRENT_INDEX_STATE,
  DIALOGS,
  DIALOGS_STATE,
  DRAWERS,
  DRAWERS_STATE,
} from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import {
  IndexState,
  IOpenState,
} from 'containers/CourtManagerLegalProceedings/JudgementAdd/typings';
import ValidationDialog from 'containers/CourtManagerLegalProceedings/AppealAdd/Dialogs/ValidationDialog';
import ProcedureInformationDrawer from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/ProcedureInformationDrawer';
import AppealAddPronouncingDrawer from 'containers/CourtManagerLegalProceedings/AppealAdd/Drawers/AppealAddPronouncingDrawer';
import { Idetails } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import { CivilParty } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { getPartiesIds } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import withLoading from 'containers/AppContainer/withLoading';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import { STATUS_VALIDATED } from 'containers/LawyerFeeNote/constants';
import { Container } from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/styled-component';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  AppealAddDocType,
  APPEAL_DOC_ID,
  EMPTY_APPEAL_ADD_DOC,
} from 'containers/LawyerLegalProceedingsPage/AppealAdd/constants';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { filterVictim } from 'containers/CourtManagerLegalProceedings/utils';
import FormsADD from 'containers/LawyerLegalProceedingsPage/AppealAdd/ProcedureInformation/FormADD';
import { detailsValidator } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/form-validation';
import {
  displayErrorText,
  validateFormFields,
} from 'containers/services/validateForm';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import {
  EMPTY_SUPPORT_DOC,
  SUPPORT_DOC_JUDGEMENT_ADD_ID,
} from 'containers/LawyerRecapPage/constants';
import { DATE_FORMAT } from 'constants/global';
import { VictimType } from 'typings/globalTypes';
export interface CourtManagerRecapAddAppealProps {
  intl: IntlShape;
  listings: Listings;
  judgementAdd: IJudgementAdd | {};
  claimId: number;
  claimNumber: string;
  requestMakeJudgementAddDecision: Function;
  victims: VictimType[];
  vehicules: Vehicule[];
  policyInfo: any;
  claim: any;
  stakeholders: any;
  assignedLawyer: any;
  judiciaryProcessId: any;
  requestGetJudgementAdd: any;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  requestMakeJudgementAddDocumentDecision: Function;
  loaders: any;
  setDocumentId: Function;
  documentId: string;
  requestCreateJudgementAdd: Function;
  currentJudiciaryProcess: any;
  isCivilProceeding: boolean;
  requestCreateMultipleJudgementAdd?: Function;
  expertReport: ExpertReportType;
  judgementOnMerits: JudgementOnMeritsType;
  requestAddSupportDocument: Function;
  setDocument: Function;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  setIsButtonRedirect: Function;
  feeNotes: any;
  setOpenFeeNoteDialog: Function;
  isConsultation: boolean;
  requestCreateIncomeCertificate: Function;
  requestUpdateIncomeCertificate: Function;
  requestMakeDecisionIncomeCertificate: Function;
  riskKey: string;
  requestMakeDecisionSupportDocument?: Function;
  imagineDocuments: any;
  requestGetDahirAmount: Function;
  dahirAmount: [];
  requestGetClaimCivilParty: Function;
  claimCivilParty: any;
  requestGetDocByDocumentumId: Function;
}

export const CourtManagerRecapAddAppeal: React.FC<CourtManagerRecapAddAppealProps> = (
  props,
): JSX.Element => {
  const [judgementAddHash, setJudgementAddHash] = useState<string>('');
  const [AppealAddDoc, setAppealAddDoc] = useState<AppealAddDocType>({
    ...EMPTY_APPEAL_ADD_DOC,
  });
  const [
    processInformationValidation,
    setProcessInformationValidation,
  ] = useState<any>({});
  const [messageError, setMessageError] = useState<any>({});
  const [judgementAddDocuments, setJudgementAddDocuments] = useState<
    JudgementADDDocumentType[]
  >([]);
  const [details, setDetails] = useState<Idetails>({
    ...cloneDeep(EMPTY_DETAIL),
    [DETAIL_JUGEMENT_ADD.COURT_FILE]: get(
      props.judgementAdd,
      'judgementAdd.courtFile',
      null,
    ),
  } as any);
  const [isCivilPartyPresent] = useState<boolean>(true);
  const [
    areProcedureInformationValidated,
    setAreProcedureInformationValidated,
  ] = useState<boolean>(false);
  useEffect(() => {
    setJudgementAdd(cloneDeep(props.judgementAdd));
    setJudgementAddHash(hash(props.judgementAdd));

    setProcedureInformations(
      cloneDeep(get(props.judgementAdd, 'judgementAdd', {})),
    );
  }, [props.judgementAdd, props.judiciaryProcessId, props.riskKey]);
  useEffect(() => {
    const procedureInformationValidation = detailsValidator(details);
    setProcessInformationValidation(procedureInformationValidation);
    const translateArrayErrorMessages = arrayTranslate(
      props.intl.formatMessage,
    );
    const { message } = displayErrorText(
      procedureInformationValidation,
      translateArrayErrorMessages(procedureInformationValidation, true),
    );
    setMessageError(message);
    setAreProcedureInformationValidated(
      !!validateFormFields(procedureInformationValidation) &&
        !(
          new Date(addDaysToDate(get(props, 'claim.lossDate') || '', 1) || '') >
          new Date(get(details, 'hearingDate') || '')
        ) &&
        moment(get(details, 'hearingDate')).format(DATE_FORMAT) !=
          'Invalid date',
    );
  }, [details]);

  const [dropDown, setDropDown] = useState<null | HTMLElement>(null);
  const [isDialogOpen, setIsDialogOpen] = useState<IOpenState>({
    ...DIALOGS_STATE,
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState<IOpenState>({
    ...DRAWERS_STATE,
  });
  const [currentIndex, setCurrentIndex] = useState<IndexState>(
    CURRENT_INDEX_STATE,
  );
  const [supportDocumentAdd, setSupportDocumentAdd] = useState({
    ...EMPTY_SUPPORT_DOC,
  });
  const [procedureInformations, setProcedureInformations] = useState<
    Idetails | {}
  >({});
  const [civilDocumentsVictims, setCivilDocumentsVictims] = useState<
    Set<number>
  >(new Set());

  const [judgementAddExpertises, setJudgementAddExpertises] = useState<
    JudgementADDDocumentType[] | []
  >([]);

  const [judgementAdd, setJudgementAdd] = useState<IJudgementAdd | {}>({});

  useEffect(() => {
    const _civilDocuments = get(props.judgementAdd, 'civilDocuments', []);
    const vicIds = getPartiesIds(
      get(_civilDocuments[currentIndex[DRAWERS.CIVIL_PARTY]], 'victims', []),
    );

    setCivilDocumentsVictims(new Set(vicIds));
  }, [currentIndex, props.judgementAdd]);
  useEffect(
    /* istanbul ignore next */ () => {
      if (!isEmpty(props.victims)) {
        const victimkeys = [
          ...without(
            uniq(
              get(props, 'victims', [])
                .filter((v: any) => v['injuryPostKey'] !== '2')
                .map((v: any) => v.victimKey),
            ),
            null,
            '',
          ),
        ];
        const deceasedVictimkeys = [
          ...without(
            uniq(
              get(props, 'victims', [])
                .filter((v: any) => v['injuryPostKey'] === '2')
                .map((v: any) => v.victimKey),
            ),
            null,
            '',
          ),
        ];
        props.requestGetDahirAmount(victimkeys, deceasedVictimkeys);
      }
      props.requestGetClaimCivilParty({ claimId: props.claimId });

      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [!isEmpty(props.victims), props.riskKey],
  );
  /* istanbul ignore next */
  const setDocument = (document: CorporealDocument) => {
    if (APPEAL_DOC_ID === String(props.documentId)) {
      setAppealAddDoc(document);
      props.resetUploadedDocument();
    }
  };
  useEffect(() => {
    setJudgementAddExpertises(
      get(props.judgementAdd, 'judgementAddDocuments', []),
    );
  }, [props.judgementAdd, props.judiciaryProcessId]);

  const handleIsDialogOpen = (
    dialog: string,
    value?: boolean,
    toUpdate: boolean = false,
    civilParty: boolean = false,
  ) => () => {
    setIsDialogOpen({
      ...isDialogOpen,
      [dialog]: !!value,
      toUpdate,
      civilParty,
    });
  };

  const handleIsDrawerOpen = (drawer: string) => (index?: number) => (
    event?: React.ChangeEvent<{}>,
  ) => {
    event && event.stopPropagation();

    const previousState = isDrawerOpen[drawer];

    setIsDrawerOpen({
      ...isDrawerOpen,
      [drawer]: !previousState,
    });

    setCurrentIndex({ ...currentIndex, [drawer]: index as number });
  };

  const customJudgementAddSetter = (
    fieldName: string,
    fieldToSet: Idetails | CivilParty[] | JudgementADDDocumentType[],
  ) => {
    setJudgementAdd({
      ...judgementAdd,
      [fieldName]: fieldToSet,
    });
  };

  const lawyer: string = get(judgementAdd, 'creator');

  const dropDownMenuElements = [
    {
      title: translate(messages.courtManagerJudgementValidate, props),
      action: handleIsDialogOpen(DIALOGS.VALIDATION, true),
    },
    {
      title: translate(messages.courtManagerJudgementRefuse, props),
      action: handleIsDialogOpen(DIALOGS.REFUSAL, true),
    },
  ];

  const setDocumentAdd = (document: CorporealDocument) => {
    if (SUPPORT_DOC_JUDGEMENT_ADD_ID === String(props.documentId)) {
      setSupportDocumentAdd(document);
      props.requestAddSupportDocument &&
        props.requestAddSupportDocument({
          ...document,
          isLawyer: false,
          status: STATUS_VALIDATED,
          judgementAddId: get(props.judgementAdd, ['judgementAdd', 'id']),
          claimId: props.claimId,
          claimNumber: props.claimNumber,
        });
      props.resetUploadedDocument();
    }
  };

  return (
    <Container>
      {shouldDisplayAddDecisionMenu(get(judgementAdd, JUDGEMENT.STATUS)) &&
        !props.isConsultation &&
        userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) && (
          <JudgementAddDecisionStyle>
            <DropDownDecisionMenu
              setDropDown={setDropDown}
              dropDown={dropDown}
              label={translate(
                recapManagerMessages.managerRecapPageDecisionButton,
                props,
              )}
              menuElements={dropDownMenuElements}
            />
          </JudgementAddDecisionStyle>
        )}
      {!isEmpty(judgementAdd) ? (
        <RecapADD
          isCivilProceeding={props.isCivilProceeding}
          listings={props.listings}
          judgementAdd={judgementAdd}
          handleOnEditCivilPartyClick={handleIsDrawerOpen(DRAWERS.CIVIL_PARTY)}
          handleOnEditJudgementAddClick={handleIsDrawerOpen(
            DRAWERS.JUDGEMENT_ADD,
          )}
          handleOnEditProcedureInfoClick={handleIsDrawerOpen(
            DRAWERS.PROCEDURE_INFORMATION,
          )}
          readOnly={props.isConsultation}
          stakeholders={props.stakeholders}
          assignedLawyer={props.assignedLawyer}
          victims={props.victims}
          vehicules={props.vehicules}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={props.resetUploadedDocument}
          claimNumber={props.claimNumber}
          judiciaryProcessId={props.judiciaryProcessId}
          requestMakeJudgementAddDocumentDecision={
            props.requestMakeJudgementAddDocumentDecision
          }
          setJudgementAdd={setJudgementAdd}
          isManager={
            !props.isConsultation &&
            userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)
          }
          isAssignedLawyer={!props.isConsultation}
          isCreator={!props.isConsultation}
          requestGetJudgementAdd={props.requestGetJudgementAdd}
          requestCreateMultipleJudgementAdd={
            props.requestCreateMultipleJudgementAdd
          }
          expertReport={props.expertReport}
          judgementOnMerits={props.judgementOnMerits}
          documentAdd={supportDocumentAdd}
          setDocumentAdd={setDocumentAdd}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          handleIsDialogOpen={handleIsDialogOpen}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          setIsButtonRedirect={props.setIsButtonRedirect}
          feeNotes={props.feeNotes}
          setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
          isConsultation={props.isConsultation}
          requestCreateIncomeCertificate={props.requestCreateIncomeCertificate}
          requestUpdateIncomeCertificate={props.requestUpdateIncomeCertificate}
          requestMakeDecisionIncomeCertificate={
            props.requestMakeDecisionIncomeCertificate
          }
          riskKey={props.riskKey}
          requestMakeDecisionSupportDocument={
            props.requestMakeDecisionSupportDocument
          }
          policyInfo={props.policyInfo}
          imagineDocuments={props.imagineDocuments}
          currentJudiciaryProcess={props.currentJudiciaryProcess}
          dahirAmount={props.dahirAmount}
          civilDocumentsVictims={props.claimCivilParty}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      ) : (
        featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
        !props.isConsultation &&
        !userPrivileges.userHasPrivilege(
          PRIVILEGES.ISCOURTMONITORINGMANAGER,
        ) && (
          <FormsADD
            judiciaryProcessId={props.judiciaryProcessId}
            document={AppealAddDoc}
            setDocument={setDocument}
            documentId={props.documentId}
            setDocumentId={props.setDocumentId}
            uploadDocument={props.uploadDocument}
            judgementAddDocuments={judgementAddDocuments}
            setJudgementAddDocuments={setJudgementAddDocuments}
            listings={props.listings}
            victims={filterVictim(props.victims)}
            vehicules={props.vehicules}
            setDetails={setDetails}
            uploadedDocument={props.uploadedDocument}
            details={details}
            resetUploadedDocument={props.resetUploadedDocument}
            canStartJudgementAdd={isCivilPartyPresent}
            canValidateJudgementAddProcedure={areProcedureInformationValidated}
            policyInfo={props.policyInfo}
            claimId={props.claimId}
            claimNumber={props.claimNumber}
            requestCreateJudgementAdd={props.requestCreateJudgementAdd}
            processInformationValidation={processInformationValidation}
            messageError={messageError}
            currentJudiciaryProcess={props.currentJudiciaryProcess}
            isCivilProceeding={props.isCivilProceeding}
            loaders={props.loaders}
            riskKey={props.riskKey}
            sagisVictimInfo={props.sagisVictimInfo}
            dahirAmount={props.dahirAmount}
            isManager={
              !props.isConsultation &&
              userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)
            }
            sagisOpposingParties={props.sagisOpposingParties}
            setIsButtonRedirect={props.setIsButtonRedirect}
            feeNotes={props.feeNotes}
            requestCreateIncomeCertificate={
              props.requestCreateIncomeCertificate
            }
            requestUpdateIncomeCertificate={
              props.requestUpdateIncomeCertificate
            }
            requestMakeDecisionIncomeCertificate={
              props.requestMakeDecisionIncomeCertificate
            }
            imagineDocuments={props.imagineDocuments}
            civilDocumentsVictims={props.claimCivilParty}
          />
        )
      )}

      <ValidationDialog
        open={isDialogOpen[DIALOGS.VALIDATION]}
        handleClose={handleIsDialogOpen(DIALOGS.VALIDATION)}
        requestMakeJudgementAddDecision={props.requestMakeJudgementAddDecision}
        lawyer={lawyer}
        claimId={props.claimId}
        claimNumber={props.claimNumber}
        judgementAdd={judgementAdd}
        judgementAddHash={judgementAddHash}
        listing={props.listings}
        policyInfo={props.policyInfo}
        claim={props.claim}
        expertReport={props.expertReport}
        judgementOnMerits={props.judgementOnMerits}
        judgementAddDocumentsHash={hash(
          get(props.judgementAdd, 'judgementAddDocuments', []),
        )}
        toUpdate={get(isDialogOpen, 'toUpdate', false)}
        civilParty={get(isDialogOpen, 'civilParty', false)}
        setIsButtonRedirect={props.setIsButtonRedirect}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
      />
      <RefusalDialog
        isRefuseDialogOpen={isDialogOpen[DIALOGS.REFUSAL]}
        handleCancel={handleIsDialogOpen(DIALOGS.REFUSAL)}
        requestMakeJudgementAddDecision={props.requestMakeJudgementAddDecision}
        claimId={props.claimId}
        claimNumber={props.claimNumber}
        lawyer={lawyer}
        judgementAdd={judgementAdd}
        claim={props.claim}
        listing={props.listings}
        judgementId={get(props.judgementAdd, 'id')}
        policyInfo={props.policyInfo}
        setIsButtonRedirect={props.setIsButtonRedirect}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
      />
      <ProcedureInformationDrawer
        open={isDrawerOpen[DRAWERS.PROCEDURE_INFORMATION]}
        handleToggleDrawer={handleIsDrawerOpen(DRAWERS.PROCEDURE_INFORMATION)()}
        details={procedureInformations as Idetails}
        setDetails={setProcedureInformations}
        listings={props.listings}
        setJudgementAdd={customJudgementAddSetter}
        vehicules={props.vehicules}
        lossDate={get(props, 'claim.lossDate')}
        sagisOpposingParties={props.sagisOpposingParties}
        currentJudiciaryProcess={props.currentJudiciaryProcess}
      />
      <AppealAddPronouncingDrawer
        open={isDrawerOpen[DRAWERS.JUDGEMENT_ADD]}
        handleToggleDrawer={handleIsDrawerOpen(DRAWERS.JUDGEMENT_ADD)()}
        victims={props.victims}
        vehicules={props.vehicules}
        setJudgementAdd={customJudgementAddSetter}
        index={currentIndex[DRAWERS.JUDGEMENT_ADD]}
        judgementAddExpertises={
          judgementAddExpertises as JudgementADDDocumentType[]
        }
        setJudgementAddExpertises={setJudgementAddExpertises}
        listings={props.listings}
        details={judgementAdd}
        resetUploadedDocument={props.resetUploadedDocument}
        uploadDocument={props.uploadDocument}
        uploadedDocument={props.uploadedDocument}
        judgementAddDocumentsStore={get(
          props.judgementAdd,
          'judgementAddDocuments',
          [],
        )}
        sagisVictimInfo={props.sagisVictimInfo}
        sagisOpposingParties={props.sagisOpposingParties}
        judgementOnMerits={props.judgementOnMerits}
      />
    </Container>
  );
};

export default injectIntl(
  withLoading(CourtManagerRecapAddAppeal, [LOADERS.JUDGEMENT_ADD]),
);
